var _document$currentScri;
var SURVEY_UI_VERSION = '3.0.16';
export var AESPluginUILoaded = false;
var isAESPluginUIloading = false;
export var isPromiseSupported = window.Promise;
var env =
// @ts-ignore
document.currentScript && ((_document$currentScri = document.currentScript) === null || _document$currentScri === void 0 || (_document$currentScri = _document$currentScri.src) === null || _document$currentScri === void 0 ? void 0 : _document$currentScri.indexOf('//dev.g.alicdn.com')) > 0 ? 'dev.' : '';

/**
 * @param {String} src
 * @param {"script" | "link"} type
 */
function _loadSource(src) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'script';
  return new Promise(function (resolve, reject) {
    var element = document.createElement(type);
    if (type === 'script') {
      element.charset = 'utf-8';
      element.async = true;
      element.src = src;
    } else {
      element.type = 'text/css';
      element.rel = 'stylesheet';
      element.href = src;
    }
    element.onload = function () {
      resolve(true);
    };
    element.onerror = function (err) {
      reject(false);
    };
    if (type === 'script') {
      (document.body || document.documentElement).appendChild(element);
    } else {
      document.head && document.head.appendChild(element);
    }
    // document.head.appendChild(element);
  });
}
export function loadPlugin() {
  return new Promise(function (resolve, reject) {
    // 已加载
    if (AESPluginUILoaded) return resolve(true);

    // 加载中
    if (isAESPluginUIloading) {
      return setTimeout(function () {
        resolve(loadPlugin());
      }, 500);
    }

    // 加载
    isAESPluginUIloading = true;
    var scriptUrl = "//".concat(env, "g.alicdn.com/aes/tracker-plugin-survey-ui/").concat(SURVEY_UI_VERSION, "/index.js");
    var cssUrl = "//".concat(env, "g.alicdn.com/aes/tracker-plugin-survey-ui/").concat(SURVEY_UI_VERSION, "/index.css");
    // const scriptUrl = `//dev.g.alicdn.com/aes/tracker-plugin-survey-ui/${SURVEY_UI_VERSION}/index.js`;
    // const cssUrl = `//dev.g.alicdn.com/aes/tracker-plugin-survey-ui/${SURVEY_UI_VERSION}/index.css`;

    Promise.all([_loadSource(scriptUrl), _loadSource(cssUrl, 'link')]).then(function () {
      // @ts-ignore
      // if ('function' === typeof window.define?.amd) {
      if ('function' === typeof window.define && window.define.amd) {
        // @ts-ignore
        var req = window.require || window.requirejs;
        if ('function' === typeof req) {
          req(["@ali/aes-tracker-plugin-survey-ui/index"], function (mod) {
            window['AESPluginSurveyUI'] = mod;
            AESPluginUILoaded = !!window['AESPluginSurveyUI'];
            resolve(AESPluginUILoaded);
          });
        }
      }
      AESPluginUILoaded = !!window['AESPluginSurveyUI'];
      resolve(AESPluginUILoaded);
    });
  });
}
var pluginUIInstance = {};
export function getPluginUI(pid) {
  return loadPlugin().then(function (loaded) {
    if (!loaded) return Promise.reject(false);
    var instance = pluginUIInstance[pid];
    if (!instance) {
      // @ts-ignore
      var getAESPluginSurveyUI = window.AESPluginSurveyUI;
      instance = getAESPluginSurveyUI();
      pluginUIInstance[pid] = instance;
    }
    return Promise.resolve(instance);
  });
}
export var getUIInstanceForClose = function getUIInstanceForClose(pid) {
  var instance = pluginUIInstance[pid];
  return Promise.resolve(instance);
};

/** 预览banner */
export function createMask(text, removeCallback) {
  var id = 'aes-tracker-plugin-sruvey-preview-banner';
  var target = document.querySelector("#".concat(id));
  if (target) {
    target.innerText = text;
  } else {
    // 创建预览条
    target = document.createElement('div');
    target.id = id;
    target.style.position = 'fixed';
    target.style.top = '0';
    target.style.left = '0';
    target.style.zIndex = '300000';
    target.style.width = '100vw';
    target.style.height = '40px';
    target.style.lineHeight = '40px';
    target.style.backgroundColor = '#ffd8df';
    target.style.textAlign = 'center';
    target.style.fontSize = '14px';
    target.innerText = text;
  }
  var closeBtn = document.createElement('a');
  closeBtn.href = 'javascript: void(0);';
  closeBtn.style.color = 'blue';
  closeBtn.style.fontSize = '14px';
  closeBtn.innerText = '结束预览';
  closeBtn.onclick = removeCallback;
  target.appendChild(closeBtn);
  if (document.body || document.documentElement) {
    (document.body || document.documentElement).appendChild(target);
  }
}
export function onHrefChange(callback) {
  var lastHref = window.location.href;
  setInterval(function () {
    if (window.location.href !== lastHref) {
      lastHref = window.location.href;
      callback();
    }
  }, 1300);
}
export function cloneObj(value) {
  var result = {};
  try {
    result = JSON.parse(JSON.stringify(value));
  } catch (error) {
    console.log(error);
  }
  return result;
}